/* eslint-disable import/prefer-default-export */

export type Primitive = number | string | boolean | undefined | null;

export type FlatParams = Record<string, Primitive | Primitive[]>;

export enum Lang {
    AZ = 'AZ',
    EN = 'EN',
    KZ = 'KZ',
    RU = 'RU',
    UA = 'UA',
    UZ = 'UZ',
    KG = 'KG',
}

export type MonthNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type QuarterNumber = 1 | 2 | 3 | 4;

export interface FeaturesStatic {
    features: Record<string, string>;
}

export enum Platform {
    HeadHunter = 'HEADHUNTER',
    Zarplata = 'ZARPLATA',
}
